import axios from 'axios';
import { urlPaymentHistory } from '../utils';

export const apiPaymentHistory = axios.create({
    baseURL: `${urlPaymentHistory}`
});